import { IPaintStyleOnEditingSpecifiable } from "../../../../../../../documaker/domain/format/objects";
import { IColorSpecifiedFeature } from "../../../../../../../base/domain/drawing";
import { IObjectBeanFixedTextDrawable } from "../../../beans/objects";
import { ColorCodeTranslator } from "../../values";

export class PaintStyleOnEditingTranslator {
  from(bean: IObjectBeanFixedTextDrawable): IColorSpecifiedFeature {
    const isEnable = !!bean["@view-bg"];
    return {
      isEnable,
      color: {
        value: this.colorCode.from(bean["@view-bg"]),
      },
    };
  }

  to(object: IPaintStyleOnEditingSpecifiable) {
    return {
      viewBg: object.paintStyleOnEditing.isEnable ? this.colorCode.to(object.paintStyleOnEditing.color.value) : undefined,
    };
  }

  private readonly colorCode = new ColorCodeTranslator();
}
